var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base_location_modal", {
    attrs: { tabs_advanced: _vm.tabs_add },
    scopedSlots: _vm._u([
      {
        key: "location_general_info",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("glovo_general_tab", { attrs: { location: location } })]
        },
      },
      {
        key: "location_categories",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [
            _c("location_super_categs", { attrs: { location: location } }),
          ]
        },
      },
      {
        key: "glovo_portal",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("glovo_portal", { attrs: { location: location } })]
        },
      },
      {
        key: "glovo_order_products",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("glovo_order_products", { attrs: { location: location } })]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }